import { Nullable } from "../models/Common";

export const unwrapPromise = async <ExpectedData extends unknown>(
  promise: Promise<Response>
): Promise<Nullable<ExpectedData>> => {
  try {
    const response: Response = await promise;
    return (await response.json()) as ExpectedData;
  } catch (e) {
    console.warn(
      `Error when trying to unwrap the promise: ${JSON.stringify(e)}`
    );
    return null;
  }
};
